module.exports = __webpack_public_path__ + "img/preview_artisprecsuzannu.2f673c48.png";